import { Observable } from "rxjs";

/**
 * Repository for the user's preference on whether the floating chat button
 * should be shown on mobile. Local-only for now, no backend persistence.
 */
export abstract class ChatFabEnabledRepo {
  abstract setChatFabEnabled(enabled: boolean): void;
  abstract observeChatFabEnabled(): Observable<boolean>;
}
